var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 34,
    viewBox: "0 0 24 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0775 0.384399C8.96457 0.388525 5.9802 1.77177 3.77904 4.2307C1.57787 6.68964 0.339631 10.0235 0.335938 13.5009C0.335937 24.7241 11.0101 33.2014 11.4646 33.5565C11.6443 33.6968 11.8582 33.772 12.0775 33.772C12.2967 33.772 12.5107 33.6968 12.6904 33.5565C13.1449 33.2014 23.819 24.7241 23.819 13.5009C23.8153 10.0235 22.5771 6.68964 20.3759 4.2307C18.1748 1.77177 15.1904 0.388525 12.0775 0.384399ZM12.0783 8.73172C12.9227 8.73172 13.7482 9.01146 14.4504 9.53556C15.1525 10.0597 15.6998 10.8046 16.0229 11.6761C16.3461 12.5477 16.4306 13.5067 16.2659 14.4319C16.1011 15.3571 15.6945 16.207 15.0974 16.874C14.5002 17.5411 13.7395 17.9953 12.9112 18.1794C12.083 18.3634 11.2245 18.269 10.4443 17.908C9.66416 17.547 8.99733 16.9356 8.52818 16.1513C8.05902 15.3669 7.80861 14.4447 7.80861 13.5014C7.8086 12.875 7.91902 12.2548 8.13359 11.6761C8.34815 11.0974 8.66265 10.5716 9.05913 10.1287C9.45561 9.68578 9.9263 9.33445 10.4443 9.09476C10.9623 8.85507 11.5176 8.73171 12.0783 8.73172Z",
    fill: "#6FC372"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIconGreen);
export default __webpack_public_path__ + "static/media/map-icon-green.18aeccdfb71d907089451a52d8add250.svg";
export { ForwardRef as ReactComponent };